import createVueApp from '@/common/create_app'
import sidebar from '@/config/sidebars/jensen'

Styxie.Initializers.JensenAbouts = {
  show: async(props) => {
    const { default: AboutsShow } = await import('@/vue_widgets/jensen/abouts/show.vue')
    createVueApp(AboutsShow, { props, sidebar })
  }
}
